// @flow
///* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

// const pattern = require('../../render/pattern');
import { beginGeojsonStencil } from "./stencil_mode";
import DepthMode from "../../gl/depth_mode";
import ColorMode from "../../gl/color_mode";
import CullFaceMode from '../../gl/cull_face_mode';
import type Painter from "../../render/painter";

import { fillUniformValues, fillPatternUniformValues } from "../../render/program/fill_program";

export default drawGeojsonStencil;

export function checkGeojsonStencil(painter: Painter, sourceCache, layer) {
    const maskSourceId = layer.paint.get("geojson-mask-source");
    if (maskSourceId) {
        return true;
    }
    return false;
}
export function getTile(sourceCache, coord) {
    const tile = sourceCache.getTile(coord);
    if (tile) {
        return tile;
    }
    const cacheTiles = sourceCache._cache.data[coord.canonical.key];
    if (!cacheTiles) {
        return tile;
    }
    const length = cacheTiles.length;
    if (length === 0) {
        return tile;
    }
    const cacheTile = cacheTiles[length - 1].value;
    return cacheTile;
}

// function geoStencil(painter, sourceCache, layer, coord) {
//     const tile = getTile(sourceCache, coord);
//     if (!tile) {
//         return;
//     }
//     const bucket = tile.getBucket(layer);
//     if (!bucket || !bucket.layoutVertexBuffer) return;

// }

export function drawGeojsonStencil(painter: Painter, sourceCache, layer, coord, backProgramName) {
    const maskLayerId = layer.paint.get("geojson-mask-source");
    const maskLayer = sourceCache.style.getLayer(maskLayerId);
    if (!maskLayer) {
        return;
    }
    const maskSourceCache = sourceCache.style.sourceCaches[maskLayer.source];
    if (!maskSourceCache) {
        return;
    }

    const posMatrix = maskSourceCache.transform.calculatePosMatrix(coord.toUnwrapped());

    const tile = getTileWithCache(maskSourceCache, coord, maskLayerId);
    if (!tile) {
        return;
    }
    const bucket = tile.getBucket(maskLayer);
    if (!bucket || !bucket.layoutVertexBuffer) {
        return;
    }
    drawFillTile(painter, maskSourceCache, maskLayer, tile, coord, posMatrix, bucket, true);
    painter.useProgram(backProgramName);
    return true;
}

function drawFillTile(painter, sourceCache, layer, tile, coord, posMatrix, bucket) {
    const gl = painter.context.gl;

    const patternProperty = layer.paint.get("fill-pattern");
    const image = patternProperty && patternProperty.constantOr((1: any));
    const crossfade = layer.getCrossfadeParameters();
    const colorMode = ColorMode.disabled;
    const depthMode = DepthMode.disabled;

    // const programName = image ? "fillPattern" : "fill";
    const programName = image ? "fillPattern" : "fill";
    const drawMode = gl.TRIANGLES;

    if (image && !tile.patternsLoaded()) return;
    if (!bucket) return;

    const programConfiguration = bucket.programConfigurations.get(layer.id);
    const program = painter.useProgram(programName, programConfiguration);

    if (image) {
        painter.context.activeTexture.set(gl.TEXTURE0);
        tile.imageAtlasTexture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
        programConfiguration.updatePatternPaintBuffers(crossfade);
    }

    const constantPattern = patternProperty.constantOr(null);
    if (constantPattern && tile.imageAtlas) {
        const posTo = tile.imageAtlas.patternPositions[constantPattern.to];
        const posFrom = tile.imageAtlas.patternPositions[constantPattern.from];
        if (posTo && posFrom) programConfiguration.setConstantPatternPositions(posTo, posFrom);
    }

    const tileMatrix = painter.translatePosMatrix(
        // posMatrix,
        posMatrix,
        tile,
        layer.paint.get("fill-translate"),
        layer.paint.get("fill-translate-anchor"),
    );

    const indexBuffer = bucket.indexBuffer;
    const segments = bucket.segments;
    const uniformValues = image
        ? fillPatternUniformValues(tileMatrix, painter, crossfade, tile)
        : fillUniformValues(tileMatrix);

    program.draw(
        painter.context,
        drawMode,
        depthMode,
        // painter.stencilModeForClipping(coord),
        beginGeojsonStencil,
        colorMode,
        CullFaceMode.disabled,
        uniformValues,
        layer.id,
        bucket.layoutVertexBuffer,
        indexBuffer,
        segments,
        layer.paint,
        painter.transform.zoom,
        programConfiguration,
    );
}

function getTileWithCache(sourceCache, coord, layerId) {
    if (!sourceCache) {
        return;
    }
    // const cacheTiles = maskSourceCache._cache.data[coord.canonical.key];
    const tile = sourceCache.getTile(coord) || sourceCache._cache.get(coord);
    if (!tile) {
        return;
    }
    const bucket = tile.buckets[layerId];
    if (!bucket || !bucket.layoutVertexBuffer) {
        return;
    }
    return tile;
}
export function getMaskTile(sourceCache, layerId, coord) {
    const maskLayer = sourceCache.style.getLayer(layerId);
    if (!maskLayer) {
        return;
    }
    const maskSourceCache = sourceCache.style.sourceCaches[maskLayer.source];
    if (!maskSourceCache) {
        return;
    }
    // const cacheTiles = maskSourceCache._cache.data[coord.canonical.key];
    const tile = getTileWithCache(maskSourceCache, coord, layerId) || maskSourceCache.findLoadedParent(coord, 0);

    return tile;
}

export function geojsonMaskIsLoaded(sourceCache, layerId, coord) {
    const maskLayer = sourceCache.style.getLayer(layerId);
    if (!maskLayer) {
        return false;
    }
    const tile = getMaskTile(sourceCache, layerId, coord);
    if (!tile) {
        return false;
    }
    const bucket = tile.getBucket(maskLayer);
    return bucket && bucket.layoutVertexBuffer;
}
